import React, { useState } from "react";
import { useHistory } from "react-router";
import validateEmail from "../../hooks/emailValidator";
import validatePassword from "../../hooks/passwordValidator";
import useForm from "../../hooks/useForm";
import Loader from "../../PhylloConnectComponents/CommonComponents/FullScreenLoader";
import { login } from "../../utils/apiHelperInternal";
import cross_icon from "../../assets/images/cross-icon.svg";
import back_icon from "../../assets/images/Back_arrow.svg";
import LabelledInput from "../../PhylloConnectComponents/CommonComponents/LabelledInput/LabelledInput";
import "./Login.scss";
function Login({ close_card }) {
  const history = useHistory();
  const [validationError, setValidationError] = useState({});
  const [errorMessage, setErrorMsg] = useState("");
  const [isLoader, setIsLoader] = useState(false);
  const initialFormData = { email: "", password: "" };
  const formValidations = [
    ({ email }) => {
      return (
        validateEmail(email) || {
          email: "Please enter a valid email.",
        }
      );
    },
    ({ password }) => {
      return (
        validatePassword(password) || {
          password: "Password should be at least 8 characters",
        }
      );
    },
  ];
  const {
    values: credentials,
    setFormData: setCredentials,
    validateFormData,
  } = useForm(initialFormData, formValidations);

  const navigateToNextPage = () => {
    return history.push("/connect");
  };

  const handleSubmitLogin = async (e) => {
    e.preventDefault();
    const validationError = validateFormData();
    const errorKeys = Object.keys(validationError);
    if (errorKeys.length > 0) {
      const errorMessage = validationError[errorKeys[0]];
      setErrorMsg(errorMessage);
      setValidationError({ [errorKeys[0]]: errorMessage });
      return;
    }

    try {
      setErrorMsg("");
      setValidationError({});
      setIsLoader(true);
      const data = await login({
        email_id: credentials.email,
        password: credentials.password,
      });
      if (data.phyllo_user_id) {
        let userId = data.phyllo_user_id;
        sessionStorage.setItem("PHYLLO_USERID", userId);

        navigateToNextPage();
      } else {
        setIsLoader(false);
        setValidationError({
          email: "enter valid email",
          password: "wrong password",
          loginError:
            "The email or password is incorrect, please check and try again.",
        });
      }
    } catch (error) {
      console.log(error);
      setIsLoader(false);
    }
  };
  return (
    <>
      {isLoader ? (
        <Loader />
      ) : (
        <div
          className="card-container login-card"
          style={(validationError.loginError || validationError.email || validationError.password) ? { height: "433px" } : { height: "398px" }}
        >
          <div className="card-content">
            <div className="card_right_icon">
              <img
                src={cross_icon}
                alt="cross_icon"
                onClick={() => close_card(false)}
              />
            </div>
            <div className="card_left_icon">
              <img
                src={back_icon}
                alt="back_icon"
                onClick={() => close_card(false)}
              />
            </div>
            <div>
              <h1 className="card-heading">Login</h1>
            </div>
            <div className="loginError">
              {validationError.loginError && validationError.loginError}
            </div>
            <form>
              <div className="input-container">
                <LabelledInput
                  name="email"
                  placeholder="Enter your email"
                  label={"Email"}
                  errorMsg={validationError.email && errorMessage}
                  onChange={setCredentials}
                  style={validationError.email && { borderColor: ERROR_COLOR }}
                />
                <LabelledInput
                  name="password"
                  placeholder="Enter your password"
                  label={"Password"}
                  errorMsg={validationError.password && errorMessage}
                  type="password"
                  onChange={setCredentials}
                  style={
                    validationError.password && { borderColor: ERROR_COLOR }
                  }
                />
              </div>
              <div>
                <button
                  className="footer-button loginButton"
                  onClick={handleSubmitLogin}
                  disabled={!credentials.password || !credentials.email}
                  style={
                    credentials.password && credentials.email
                      ? {}
                      : { opacity: "60%" }
                  }
                >
                  Login
                </button>
              </div>
            </form>
          </div>
        </div>
      )
      }
    </>
  );
}
const ERROR_COLOR = "#AF5454";

export default Login;
